import {ControlledAutocompleteSelect} from '@hm/fundamental'
import React, {FC, useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {useSections} from '../../hooks'

type CategoryFilterDropdownProps = {
  value: string[]
  onChange: (value: string[]) => void
}

const ALL = '__all__'

export const CategoryFilterDropdown: FC<CategoryFilterDropdownProps> = ({value, onChange}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {data: sections = []} = useSections()

  const options = useMemo(() => {
    const sectionOptions = sections.map((section) => ({
      label: section.name,
      value: section.id
    }))
    return [
      {
        label: t('comparativeAnalysis.chart.categoryFilter.all', {count: sections.length}),
        value: ALL
      },
      ...sectionOptions
    ]
  }, [sections, t])

  const selectedValues = useMemo(() => (value.length === 0 ? [ALL] : value), [value])

  return (
    <div className="w-full max-w-[300px] [&_[data-cy='category-filter-dropdown-clear']]:hidden">
      <ControlledAutocompleteSelect
        label={t('comparativeAnalysis.chart.categoryFilter.label')}
        options={options}
        isMultiSelect
        selectedValues={selectedValues}
        onChange={(values) => {
          const lastSelected = values[values.length - 1]

          if (lastSelected === ALL) {
            onChange([])
            return
          }

          const filtered = values.filter((v) => v !== ALL) as string[]
          onChange(filtered)
        }}
        data-cy="category-filter-dropdown"
      />
    </div>
  )
}
